import * as Yup from 'yup';

const schema = Yup.object().shape({
  nome: Yup.string().required('Valor requerido'),
  icon: Yup.string().required('Valor requerido'),
  path_name: Yup.string().required('Valor requerido'),
});

export default schema;
